import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PointTransactionRequest } from "./PointTransactionRequest";
import { GroupPointsInsertRequest } from "./GroupPointsInsertRequest";

@Injectable()
export class DataService_Student_Point {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	PBISPointSelectList(PersonID, StartDate, EndDate, ShowVoid) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISPointSelectList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate + "&ShowVoid=" + ShowVoid;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISGetBalance(PersonID) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISGetBalance?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointItemSelectList(PointsCategoryTypeID, SchoolID) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISPointItemSelectList?PointsCategoryTypeID=" + PointsCategoryTypeID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TransactionInsert(parms: PointTransactionRequest) {
		var postResult$ = new Subject();
		var url = "PBIS/TransactionInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointVoid(PointsTransactionID) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISPointVoid?PointsTransactionID=" + PointsTransactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISPointDelete(PointsTransactionID) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISPointDelete?PointsTransactionID=" + PointsTransactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PBISGroupSelectList(GroupID, StartDate, EndDate, ShowVoid) {
		var postResult$ = new Subject();
		var url = "PBIS/PBISGroupSelectList?GroupID=" + GroupID + "&StartDate=" + StartDate + "&EndDate=" + EndDate + "&ShowVoid=" + ShowVoid;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupPointsInsert(parms: GroupPointsInsertRequest) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupPointsVoid(PointsGroupTransactionID) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsVoid?PointsGroupTransactionID=" + PointsGroupTransactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupPointsDelete(PointsGroupTransactionID) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsDelete?PointsGroupTransactionID=" + PointsGroupTransactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupPointsAddMissing(PointsGroupTransactionID, c_PersonID) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsAddMissing?PointsGroupTransactionID=" + PointsGroupTransactionID + "&c_PersonID=" + c_PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupPointsUpdateStudentPrompt(PointsGroupTransactionID, AddStudentPrompt) {
		var postResult$ = new Subject();
		var url = "PBIS/GroupPointsUpdateStudentPrompt?PointsGroupTransactionID=" + PointsGroupTransactionID + "&AddStudentPrompt=" + AddStudentPrompt;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
